import Column from '@app/components/layout/Column'
import { useLanguage } from '@i18n/useLanguage'
import { i18n } from '@i18n/index'
import { GeoViewModel } from './models'
import { PdfViewer } from '@app/components/core/pdfViewer/PdfViewer'
import { Title } from '@app/components/core/typography/Title'

export const StepByStep = ({ region }: { region: GeoViewModel }) => {
  const [language] = useLanguage()
  const translations = i18n.languages[language].app.regionPage
  const pdf = region.stepByStepPdf

  if (!pdf?.src) {
    return null
  }

  return (
    <Column gap="1.5rem" alignItems="stretch">
      <Title.H4 style={{ marginBottom: '1rem' }}>
        {translations.pageTabTitle.stepByStep.replace('{0}', region.name)}
      </Title.H4>
      <PdfViewer
        src={pdf.src}
        fileName={pdf.name}
        downloadLabel={translations.downloadStepByStepPdf}
      />
    </Column>
  )
}
